export default __webpack_public_path__ + "static/media/dashboard-work-logo.db6138a1.svg";